import React, { useState, useEffect } from 'react';
import { Row, Card, CardBody, Button, Table, Spinner, Alert, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { connect } from 'react-redux';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Internal_Property_By_Id,
  getAPI_ActiveFacilities,
  getAPI_WorkOrderTypes,
  postAPI_WorkOrderTypes_Import,
  putAPI_WorkOrderTypes,
} from '../../../../../../constants/APIs';
import WorkOrderEditModal from './WorkOrderEditModal';
import LanguageTabs from '../../../propinfo/components/LanguageTabs/LanguageTabs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';


const SOURCE_FILTER_OPTIONS = [
  { label: 'Flexkeeping', value: 'Flexkeeping' },
  { label: 'BPN', value: 'Bpn' }
];

const WorkOrders = ({ propertyId, userName }) => {
  const [workOrders, setWorkOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [importError, setImportError] = useState(null);
  const [activeFacilities, setActiveFacilities] = useState([]);
  const [propertyLanguages, setPropertyLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const [selectedSource, setSelectedSource] = useState('');
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState(null);

  // Edit modal state
  const [editItem, setEditItem] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);

  //Imports utils
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);


  const fetchWorkOrders = () => {
    if (!propertyId) return;

    setLoading(true);
    setError(null);

    AxiosAPI({
      method: 'get',
      url: getAPI_WorkOrderTypes,
      params: {
        groupId: getGroupID(),
        propertyId: propertyId,
        source: selectedSource || '',
      },
    })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        setWorkOrders(data);
      })
      .catch((err) => {
        console.error('Error fetching work order types:', err);
        setError('Failed to load work orders. Please try again.');
      })
      .finally(() => setLoading(false));
  };

  const fetchActiveFacilities = () => {
    if (!propertyId) return;

    setLoading(true);

    AxiosAPI({
      method: 'get',
      url: getAPI_ActiveFacilities,
      params: {
        groupId: getGroupID(),
        channel: 'Flexkeeping',
      },
    })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        setActiveFacilities(data);
      })
      .catch((err) => {
        console.error('Error fetching work order types:', err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchActiveFacilities();
  }, [propertyId]);

  const handleImport = (source) => {
    if (!propertyId || importing) return;

    setImporting(true);
    setImportResult(null);
    setImportError(null);

    AxiosAPI({
      method: 'post',
      url: postAPI_WorkOrderTypes_Import,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId,
        creator: userName || 'SystemAdmin',
        Source: source,
      },
    })
      .then((res) => {
        const {
          importedCount = 0,
          skippedCount = 0,
          updatedCount = 0,
        } = res.data || {};
        setImportResult({ importedCount, skippedCount, updatedCount });
        fetchWorkOrders();
      })
      .catch((err) => {
        console.error(
          'Error importing work order types:',
          err?.response?.data?.Messages?.[0]
        );
        setImportError(
          err?.response?.data?.Messages?.[0] ||
          'Import failed. Please try again.'
        );
      })
      .finally(() => setImporting(false));
  };

  const handleEditClick = (item) => {
    setEditItem(item);
    setEditOpen(true);
  };

  const handleDeleteClick = async (id) => {
    const payload = {
      modifier: userName ?? 'dashboard',
    };
    const response = await AxiosAPI({
      method: 'delete',
      url: `${putAPI_WorkOrderTypes}/${id}`,
      data: payload,
    });

    if (response?.status == 200) {
      setWorkOrders((prev) => prev.filter((wo) => wo.id !== id));
      NotificationManager.success(
        '',
        'Work Order deleted successfully',
        3000,
        null,
        null,
        'success'
      );
    } else {
      NotificationManager.error(
        '',
        'Failed to delete work order',
        3000,
        null,
        null,
        'error'
      );
    }
  };

  const handleSave = async (updatedItem) => {
    const { appearance } = updatedItem;
    const updatedAppearance = appearance ? JSON.stringify(appearance) : '';
    setSaving(true);
    // Placeholder: replace with actual PUT API call when ready
    const response = await AxiosAPI({
      method: 'put',
      url: `${putAPI_WorkOrderTypes}/${updatedItem.id}`,
      data: {
        ...updatedItem,
        appearance: updatedAppearance,
        modifier: userName ?? 'system',
      },
    });

    if (response?.status == 200) {
      setWorkOrders((prev) =>
        prev.map((wo) => (wo.id === updatedItem.id ? updatedItem : wo))
      );
      setSaving(false);
      setEditOpen(false);
      setEditItem(null);
      NotificationManager.success(
        '',
        'Work Order updated successfully',
        3000,
        null,
        null,
        'success'
      );
    } else {
      NotificationManager.error(
        '',
        'Failed to update work order',
        3000,
        null,
        null,
        'error'
      );
    }
    // setTimeout(() => {
    //   setWorkOrders((prev) =>
    //     prev.map((wo) => (wo.id === updatedItem.id ? updatedItem : wo))
    //   );
    //   setSaving(false);
    //   setEditOpen(false);
    //   setEditItem(null);
    // }, 400);
  };

  useEffect(() => {
    fetchWorkOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyId, refreshFlag]);

  useEffect(() => {

    if (propertyId) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setPropertyDetails(res.data);
        })
        .catch((err) => console.error(err));
    }
  }, [propertyId])

  const getWorkOrderName = (item, langCode = selectedLanguage) => {
    if (!Array.isArray(item.name) || item.name.length === 0) return '-';
    const langCodeEntry = item.name.find((n) => n.languageCode === langCode);
    const enEntry = item.name.find((n) => n.languageCode === 'en');
    return langCodeEntry ? langCodeEntry.statement : enEntry.statement;
  };

  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).replace('_', ' ') : '-';

  const setLanguage = (e) => {
    var lan = e;
    if (e === 'zh-TW') {
      lan = 'hk';
    }
    setSelectedLanguage(lan);
  };

  const toggleFilterPanel = () => {
    setIsFilterPanelOpen((prev) => {
      const next = !prev;
      return next;
    });
  };

  const handleClearStatusFilter = () => {
    setIsFilterPanelOpen(false);
    setRefreshFlag((prev) => !prev);
    setSelectedSource('');
  };

  const handleApplyStatusFilter = () => {
    setIsFilterPanelOpen(false);
    setRefreshFlag((prev) => !prev);
  };

  return (
    <div>
      <Row>
        <Colxx xxs="12" className="d-flex align-items-center gap-2">
          {/* <Button outline color="primary" className="mb-2 mr-3" style={{ borderRadius: '50px' }}>
            + Add New
          </Button> */}
          {/* <Button
            outline
            color="primary"
            size="xs"
            className="mb-2"
            // style={{ borderRadius: '50px' }}
            onClick={handleImport}
            disabled={importing}
          >
            {importing ? (
              <>
                <Spinner size="sm" className="mr-1" /> Importing...
              </>
            ) : (
              '+ Import'
            )}
          </Button> */}



          <div className="position-relative mr-2">
            <Button
              color="primary"
              size="xs"
              className="d-flex align-items-center"
              onClick={toggleFilterPanel}
            >
              <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />
              Filters
              <i
                className={`simple-icon-arrow-${isFilterPanelOpen ? 'up' : 'down'} ml-2`}
                style={{ fontSize: 10 }}
              />
            </Button>

            {isFilterPanelOpen && (
              <div
                className="reservation-filter-panel"
                style={{
                  position: 'absolute',
                  top: '110%',
                  left: 0,
                  width: 260,
                  zIndex: 12,
                  background: '#fff',
                  borderRadius: 12,
                  boxShadow: '0 10px 30px rgba(15, 34, 58, 0.15)',
                  padding: '16px',
                }}
              >
                <div className="mb-3">
                  <label className="text-small font-weight-semibold d-block mb-1">
                    Source
                  </label>
                  <Select
                    isMulti={false}
                    options={SOURCE_FILTER_OPTIONS}
                    className="react-select"
                    classNamePrefix="react-select"
                    placeholder="Select Source"
                    value={selectedSource ? { value: selectedSource, label: selectedSource } : null}
                    onChange={(val) => {
                      setSelectedSource(val ? val.value : '');
                    }}
                  />
                </div>
                <div className="d-flex justify-content-end mt-4 pt-2 border-top">
                  <Button
                    size="xs"
                    color="secondary"
                    onClick={handleClearStatusFilter}
                  >
                    Clear
                  </Button>
                  <Button
                    size="xs"
                    color="primary"
                    className="ml-2"
                    onClick={handleApplyStatusFilter}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            )}
          </div>

          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle outline caret color='primary' size="xs"
              disabled={importing}>
              {importing ? (
                <>
                  <Spinner size="sm" className="mr-1" /> Importing...
                </>
              ) : (
                '+ Import'
              )}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem header>Choose Import For</DropdownItem>
              <DropdownItem onClick={() => handleImport("Flexkeeping")}>Flexkeeping</DropdownItem>
              <DropdownItem onClick={() => handleImport("BPN")}>BPN</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Colxx>
      </Row>
      <Row className="mb-3">
        <Colxx xxs="12">
          <LanguageTabs
            selectedTab={selectedLanguage === 'hk' ? 'zh-TW' : selectedLanguage}
            setLanguage={setLanguage}
            getPropertyLanguage={(langs) => setPropertyLanguages(langs)}
          ></LanguageTabs>
        </Colxx>
      </Row>

      {importResult && (
        <Row className="mb-3">
          <Colxx xxs="12">
            <Alert color="success" toggle={() => setImportResult(null)}>
              Import complete — <strong>{importResult.importedCount}</strong>{' '}
              imported, <strong>{importResult.skippedCount}</strong> skipped,{' '}
              <strong>{importResult.updatedCount}</strong> updated.
            </Alert >
          </Colxx >
        </Row >
      )}

      {
        importError && (
          <Row className="mb-3">
            <Colxx xxs="12">
              <Alert color="danger" toggle={() => setImportError(null)}>
                {importError}
              </Alert>
            </Colxx>
          </Row>
        )
      }

      <Row>
        <Colxx xxs="12">
          {loading ? (
            <div className="text-center p-5">
              <Spinner color="primary" />
            </div>
          ) : error ? (
            <div className="text-center p-4 text-danger">{error}</div>
          ) : (
            <Card>
              <CardBody className="p-0">
                <Table
                  responsive
                  className="mb-0"
                  style={{ borderCollapse: 'collapse' }}
                >
                  <thead>
                    <tr style={{ backgroundColor: '#f3f3f3' }}>
                      <th className="px-3 py-2">
                        <b>Work Order</b>
                      </th>
                      <th className="px-3 py-2">
                        <b>Item Type</b>
                      </th>
                      <th className="px-3 py-2">
                        <b>Facilities</b>
                      </th>
                      <th className="px-3 py-2">
                        <b>Source</b>
                      </th>
                      <th className="px-3 py-2">
                        <b>External Item ID</b>
                      </th>
                      <th className="px-3 py-2">
                        <b>Price</b>
                      </th>
                      <th className="px-3 py-2">
                        <b>Image</b>
                      </th>
                      <th className="px-3 py-2">
                        <b>Actions</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {workOrders.length === 0 ? (
                      <tr>
                        <td colSpan={8} className="text-center py-4 text-muted">
                          No work orders found.
                        </td>
                      </tr>
                    ) : (
                      workOrders.map((item) => {
                        const facilityRecord = activeFacilities.find(
                          (facility) => facility.id == item.facilityId
                        );
                        return (
                          <tr
                            key={item.id}
                            style={{ borderBottom: '1px solid #f0f0f0' }}
                          >
                            <td className="px-3 py-2">
                              {getWorkOrderName(item)}
                            </td>
                            <td className="px-3 py-2">
                              {capitalize(item.type)}
                            </td>
                            <td className="px-3 py-2">
                              {facilityRecord?.title || item.facilityId || propertyDetails?.name || '-'}
                            </td>
                            <td className="px-3 py-2">
                              {item.source || 'Flexkeeping'}
                            </td>
                            <td className="px-3 py-2">{item.code || '-'}</td>
                            <td className="px-3 py-2">
                              {item.price != null ? `$${item.price}` : '$0'}
                            </td>
                            <td className="px-3 py-2">
                              {item.imageLink ? (
                                <img
                                  src={item.imageLink}
                                  alt="work order"
                                  style={{
                                    width: '68px',
                                    height: '56px',
                                    objectFit: 'cover',
                                    borderRadius: '4px',
                                    border: '1px solid #dee2e6',
                                  }}
                                />
                              ) : (
                                <span
                                  className="text-muted"
                                  style={{ fontSize: '12px' }}
                                >
                                  —
                                </span>
                              )}
                            </td>
                            <td className="px-3 py-2">
                              <Button
                                size="xs"
                                color="primary"
                                outline
                                onClick={() => handleEditClick(item)}
                              >
                                Edit
                              </Button>
                              <Button
                                size="xs"
                                color="danger"
                                outline
                                onClick={() => handleDeleteClick(item.id)}
                                className="ml-2"
                              >
                                Delete
                              </Button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          )}
        </Colxx>
      </Row>

      {/* Edit Modal */}
      {
        editOpen && editItem && (
          <WorkOrderEditModal
            isOpen={editOpen}
            toggle={() => {
              setEditOpen(false);
              setEditItem(null);
            }}
            item={editItem}
            saving={saving}
            onSave={handleSave}
            langCode={selectedLanguage}
          />
        )
      }
    </div >
  );
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, userName } = settings;
  return { propertyId, userName };
};

export default connect(mapStateToProps, {})(WorkOrders);
